import { z } from 'zod';
// =============================================================================
// SSE EVENT TYPES (Vercel AI SDK UI Message Stream)
// =============================================================================
export const SSE_EVENT_TYPES = {
    START: 'start',
    START_STEP: 'start-step',
    TEXT_START: 'text-start',
    TEXT_DELTA: 'text-delta',
    TEXT_END: 'text-end',
    TOOL_CALL: 'tool-call',
    TOOL_INPUT_START: 'tool-input-start',
    TOOL_INPUT_AVAILABLE: 'tool-input-available',
    TOOL_RESULT: 'tool-result',
    TOOL_OUTPUT_AVAILABLE: 'tool-output-available',
    FINISH_STEP: 'finish-step',
    FINISH: 'finish',
};
// =============================================================================
// EVENT SCHEMAS
// =============================================================================
export const TextDeltaEventSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.TEXT_DELTA),
    id: z.string().optional(),
    delta: z.string(),
});
export const ToolCallEventSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.TOOL_CALL),
    toolCallId: z.string(),
    toolName: z.string(),
    args: z.record(z.unknown()),
});
export const ToolResultEventSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.TOOL_RESULT),
    toolCallId: z.string(),
    result: z.unknown(),
});
export const ToolInputAvailableSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.TOOL_INPUT_AVAILABLE),
    toolCallId: z.string(),
    toolName: z.string(),
    input: z.record(z.unknown()),
});
export const ToolOutputAvailableSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.TOOL_OUTPUT_AVAILABLE),
    toolCallId: z.string(),
    output: z.unknown(),
});
export const FinishEventSchema = z.object({
    type: z.literal(SSE_EVENT_TYPES.FINISH),
    finishReason: z.string(),
    usage: z.object({
        promptTokens: z.number(),
        completionTokens: z.number(),
        totalTokens: z.number(),
    }).optional(),
});
